//@flow

import {updateContactNameService} from '../promises';
import {useState} from 'react';

export function useContactActions() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateName = (identifier: string, name: string) => {
    setLoading(true);
    return updateContactNameService(identifier, name)
      .then(() => {
        return true;
      })
      .catch(error => {
        setError(error);
        return false;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    loading,
    error,
    updateName,
  };
}
